import React from 'react';
import { FadeIn } from './FadeIn';
export function TomosSection() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1',
    desc: 'Administración y Control Financiero · Caja diaria · Costos por servicio · Inventario · Metas mensuales'
  }, {
    icon: '📗',
    title: 'Tomo 2',
    desc: 'Clientes y Agenda · Ficha técnica · Sistema anti no-show en 3 capas · Señas · Reactivación'
  }, {
    icon: '📙',
    title: 'Tomo 3',
    desc: 'Scripts de WhatsApp Listos · 40+ mensajes · Confirmaciones · Recordatorios · Aumentos · Reclamos'
  }, {
    icon: '📕',
    title: 'Tomo 4',
    desc: 'Redes Sociales y Contenido · 5 tipos de posts que generan turnos · Calendario mensual · Pies de foto'
  }, {
    icon: '📓',
    title: 'Tomo 5',
    desc: 'Legal y Seguridad · Consentimiento informado · Protocolo de alergias · Deslinde · Reclamos'
  }, {
    icon: '📔',
    title: 'Tomo 6',
    desc: 'Crecimiento y Upsell · Estrategia de precios · Menú VIP en 3 niveles · Aumentar ticket promedio'
  }];
  return <section className="py-12 px-4 max-w-5xl mx-auto" data-id="element-339">
      <FadeIn data-id="element-340">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-341">
          <span className="text-4xl" data-id="element-342">📚</span> LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-343">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-344">
            <div className="bg-gray-900 border border-gray-800 hover:border-pink-500/50 transition-colors rounded-xl p-6 h-full flex flex-col" data-id="element-345">
              <div className="text-4xl mb-4" data-id="element-346">{tomo.icon}</div>
              <h3 className="text-xl font-bold text-pink-400 mb-2" data-id="element-347">
                {tomo.title}
              </h3>
              <p className="text-gray-300 font-medium leading-relaxed flex-grow" data-id="element-348">
                {tomo.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}